import { styled } from '@mui/material';

export const TableContainer = styled('div')({
  marginBottom: 20,
});
